<template>
  <div>
    <div class="tw-mt-3">
      <back-nav
          :to="$route.query.b === 'health' ? 'PersonalDetailsHealth' : $route.name === 'InstalmentPayment' ? 'Instalments' :  'PaymentSelection'"/>
    </div>

    <v-card flat class="mx-auto tw-px-2 md:tw-px-4 tw-py-2 md:tw-py-4">
      <p class="c-navy-text tw-font-bold tw-px-0 md:tw-px-10">
        {{ data.quoteInfo.payPercentage === 100 ? 'Full Payment' : 'Installment Payment' }}</p>
      <div class="tw-w-full tw-flex">
        <div class="tw-w-full tw-flex tw-justify-center tw-items-center tw-my-5 md:tw-my-8 tw-flex-wrap">
          <div class="tw-flex tw-px-2 md:tw-px-10">
            <v-icon color="primary" size="90" alt="car">
              {{ data.quoteInfo.coverType === 'Pacis Amani Cover' ? 'mdi-hospital-box-outline' : data.quoteInfo.coverType === 'Domestic Package Cover' ? 'mdi-home-circle-outline' : 'mdi-car-outline' }}
            </v-icon>
            <h3 class="c-navy-text c-title tw-text-base md:tw-text-xl tw-px-2 md:tw-px-8"><span
                v-html="data.quoteInfo.coverType"></span></h3>
          </div>
          <div v-if="data.quoteInfo.coverType !== 'Pacis Amani Cover'"
               class="tw-flex tw-grid tw-grid-cols-1 tw-px-2 md:tw-px-10 tw-text-center lg:tw-text-left">
            <h1 class="tw-w-full c-navy-text tw-font-bold tw-text-5xl md:tw-text-6xl">{{
                data.quoteInfo.payPercentage
              }}%</h1>
            <p class="tw-w-full c-navy-text tw-text-sm md:tw-text-base">of the sum insured</p>
          </div>
          <div class="tw-px-0 md:tw-px-10 tw-mt-5 md:tw-mt-0">
            <h4 class="c-blue-text tw-font-bold tw-text-sm">
              {{ data.quoteInfo.payPercentage === 100 ? 'Total Annual' : 'Installment' }} Premium</h4>
            <h3 class="c-light-blue-text title-font tw-text-4xl md:tw-text-5xl">Kshs.
              {{ data.payment.payableAmount | formatNum }}</h3>
          </div>
        </div>
      </div>
    </v-card>

    <v-card flat class="tw-mt-5 md:tw-mt-16 tw-pb-10">
      <div class="tw-px-4 md:tw-px-8">
        <card-title icon="mdi-cash">Choose your Mode of payment</card-title>
      </div>
      <div class="tw-flex tw-justify-center tw-px-4 md:tw-px-12 tw-mt-4 md:tw-mt-10">
        <div v-if="!paymentInitiated" class="tw-w-full md:tw-w-8/12">
          <v-tabs
              v-model="tab"
              centered
              icons-and-text
          >

            <v-tab v-if="stkSupported" href="#tab-1" class="tw-px-2" @click="currentTab = 'stk'">
              <img :src="[currentTab === 'stk' ? '/images/payment/mpesa-b.png' : '/images/payment/mpesa.png']"
                   width="120" alt="mpesa">
            </v-tab>

            <v-tab v-if="paymentGatewaySupported" href="#tab-2" class="tw-px-2" @click="currentTab = 'paymentGateway'">
              <img :src="[currentTab === 'paymentGateway' ? '/images/payment/bank-b.png' : '/images/payment/bank.png']"
                   width="120" alt="mpesa">
            </v-tab>

            <v-tab v-if="walletSupported" href="#tab-3" class="tw-px-2" @click="currentTab = 'wallet'">
              <img :src="[currentTab === 'wallet' ? '/images/payment/wallet-b.png' : '/images/payment/wallet.png']"
                   width="120" alt="wallet">
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item value="tab-1">
              <v-card class="tw-flex tw-justify-center" flat>
                <div class="tw-w-full md:tw-w-8/12 tw-px-2 md:tw-px-8 tw-py-2 md:tw-py-8">
                  <p class="c-blue-text">Enter the Phone Number to pay from</p>
                  <v-form v-model="stkValid">
                    <v-text-field v-model="form.customerPhoneNumber" type="text" label="Phone Number"
                                  class="tw-w-full md:tw-w-8/12 offset-md-2 my-3 tw-mt-4"
                                  :rules="[required('Phone Number'), mobileFormat()]"></v-text-field>
                    <v-card-actions class="col-sm-4 offset-sm-4 tw-mt-5 tw-pb-8">
                      <v-btn block large
                             color="secondary"
                             class="my-3 "
                             :loading="loading"
                             :disabled="!stkValid"
                             @click="requestSTK"
                      >
                        Pay
                      </v-btn>
                    </v-card-actions>
                  </v-form>
                </div>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-2">
              <v-card class="tw-flex tw-justify-center" flat>
                <div class="tw-w-full md:tw-w-8/12 tw-px-2 md:tw-px-8 tw-py-2 md:tw-py-8">
                  <!-- <p class="c-blue-text">Bank Details;</p>
                  <ul class="tw-mt-4">
                    <li>Bank & Branch: NCBA, Westlands.</li>
                    <li>Branch Code: 105</li>
                    <li>Bank Code: 07</li>
                    <li>Account name: Pacis Insurance Company Limited.</li>
                    <li>Account number: 1000015195</li>
                    <li>Swift code: CBAFKENX</li>
                    <li>Enter Amount: <strong>34000</strong></li> -->
                  <!-- </ul> -->
                  <!-- <button class="checkout-button"></button> -->
                  <v-btn class="awesome-checkout-button my-3" block large
                         color="secondary" @click="requestPaymentGateway">Pay Now
                  </v-btn>
                  OR
                  <p class="c-blue-text">Enter the phone number to receive payment link</p>
                  <v-form>
                    <v-text-field v-model="form.customerPhoneNumber" type="text" label="Phone Number"
                                  class="tw-w-full md:tw-w-8/12 offset-md-2 my-3 tw-mt-4"
                                  :rules="[required('Phone Number'), mobileFormat()]"></v-text-field>
                    <v-card-actions class="col-sm-4 offset-sm-4 tw-mt-5 tw-pb-8">
                      <v-btn block large
                             color="secondary"
                             class="my-3 "
                             :loading="loading"
                             @click="payByLink"
                      >
                        Pay By Link
                      </v-btn>
                    </v-card-actions>
                  </v-form>
                  <!-- <v-btn class="awesome-checkout-button my-3" block large
                         color="secondary" @click="payByLink">Share payment link to phone
                  </v-btn> -->
                  <!-- <v-btn class="awesome-checkout-button" block large -->
                  <!-- color="secondary" @click="requestPaymentGateway">Proceed to Payment</v-btn> -->
                  <!-- <p class="c-blue-text tw-mt-4">Enter the transaction code you received from MPESA</p>
                  <v-text-field type="text" label="Transaction Code" class="tw-w-full md:tw-w-8/12 offset-md-2 my-3 tw-mt-4"></v-text-field>
                  <v-card-actions class="col-sm-6 offset-sm-3 tw-mt-5 tw-pb-8">
                    <v-btn block large
                           color="secondary"
                           class="my-3 "
                           :loading="loading"
                           @click="alert('Pending ....')"
                    >
                     Confirm Payment
                    </v-btn>
                  </v-card-actions> -->
                </div>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-3">
              <v-card class="tw-flex tw-justify-center" flat>
                <div class="tw-w-full md:tw-w-8/12 tw-px-2 md:tw-px-8 tw-py-2 md:tw-py-8">
                  <p class="c-blue-text">Do you want to pay Kshs. 75,000 to Pacis Insurance Limited, Enter Login
                    Password</p>
                  <v-text-field type="text" label="Password"
                                class="tw-w-full md:tw-w-8/12 offset-md-2 my-3 tw-mt-4"></v-text-field>
                  <v-card-actions class="col-sm-4 offset-sm-4 tw-mt-5 tw-pb-8">
                    <v-btn block large
                           color="secondary"
                           class="my-3"
                           :loading="loading"
                           @click="alert('Pending ....')"
                    >
                      Pay
                    </v-btn>
                  </v-card-actions>
                </div>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
          <div class="tw-flex tw-justify-center">
            <div class="tw-w-full md:tw-w-8/12 tw-px-2 md:tw-px-8">
              <p class="c-blue-text tw-mt-4"><small>Note: The transaction name that will reflect in your statement is
                ‘Pacis Insurance’</small></p>
              <p class="c-gray-text tw-mt-4">For assistance: <span class="c-blue-text">0720113122</span></p>
            </div>
          </div>
        </div>
        <div v-else class="tw-w-full md:tw-w-8/12 tw-flex tw-justify-center tw-flex-col">
          <div>
            <div v-if="!notificationAllowed" class="tw-w-full tw-px-4 md:tw-px-8">
              <div
                  class="tw-w-full md:tw-w-full tw-my-4 tw-flex tw-items-center tw-bg-blue-200 tw-text-center lg:tw-text-left tw-rounded-lg lg:tw-rounded-lg tw-border-blue-500 tw-px-2 md:tw-px-6 tw-py-3 tw-flex tw-justify-between"
                  role="alert">
                <p>Allow Notifications to see receive important updates </p>
                <span class="tw-bg-blue-500 tw-px-4 tw-py-0 tw-rounded-lg lg:tw-rounded-lg tw-text-sm tw-cursor-pointer"
                      @click="requestNotification">ALLOW</span>
              </div>
            </div>

            <div v-if="notificationDenied" class="tw-w-full tw-px-4 md:tw-px-8">
              <div
                  class="tw-w-full md:tw-w-full tw-my-4 tw-flex tw-items-center tw-bg-orange-200 tw-rounded-lg lg:tw-rounded-lg tw-border-orange-500 tw-px-2 md:tw-px-6 tw-py-3 tw-flex tw-justify-between"
                  role="alert">
                <p>Notifications BLOCKED! Allow Notifications to receive important updates, Go to site settings to
                  allow </p>
              </div>
            </div>
          </div>
          <div v-if="paymentStatus === 'PENDING'" class="tw-flex tw-justify-center">
            <img class="tw-w-32 md:tw-w-40" src="/images/hourglass.gif" alt="loading">
          </div>
          <div class="tw-text-center">
            <h2 :class="[paymentStatus === 'FAILED' || paymentStatus === null ? 'tw-text-red-500' : 'tw-text-green-500' , 'tw-text-xl md:tw-text-3xl tw-mb-3']">
              {{
                paymentStatus === 'PENDING' ? 'Check your mobile for a payment request via MPESA' : paymentStatus === 'SUCCESSFUL' ? 'Payment Was Successful' : 'Payment Failed, Something went wrong!'
              }}</h2>
            <div v-if="paymentStatus === 'PENDING'">
              <p class="c-gray-text">Check your phone for MPESA payment request, <br> Enter your MPESA pin to complete
                the process
              </p>
              <p class="c-gray-text tw-mt-2">You will receive a notification on successful payment regarding your
                policy</p>
              <p class="c-gray-text tw-mt-2">This will take a few minutes</p>
            </div>
          </div>
          <div v-if="!statusLoaded"
               class="tw-w-full lg:tw-w-3/4 tw-self-center tw-bg-orange-200 tw-rounded-lg tw-p-4 md:tw-mt-8 c-gray-text tw-mt-4">
            <p>In case you did not receive the payment request on your mobile phone, <br>
              Kindly dial *234*1*6# to allow you to receive the payment request when transacting
            </p>
          </div>
          <div v-if="statusLoaded" class="tw-w-full lg:tw-w-3/4 tw-self-center">
            <div v-if="paymentStatus === 'SUCCESSFUL' && data.quoteInfo.coverType !== 'Pacis Amani Cover'"
                 class="tw-bg-green-200 tw-rounded-lg tw-p-4 md:tw-mt-8 c-gray-text tw-mt-4">
              <p><strong>Your Payment was received successfully.</strong> <br>
                Your policy is currently being processed. Thank you for choosing us as your preferred insurer. Pacis,
                For Comfort & Peace in Life.</p>

              <div class="tw-mt-4 tw-mt-8 tw-px-4 tw-flex tw-justify-center">
                <v-btn
                    :to="{name: 'MyPolicies'}"
                    color="secondary"
                >View My Policies
                </v-btn>
              </div>
            </div>
            <div v-if="paymentStatus === 'SUCCESSFUL'"
                 class="tw-bg-green-200 tw-rounded-lg tw-p-4 md:tw-mt-8 c-gray-text tw-mt-4">
              <p><strong>Your Payment was received successfully.</strong> <br>
                Kindly proceed to share the documents as highlighted in the sms for the processing of your policy. Thank
                you for choosing us as your preferred insurer. Pacis, For Comfort & Peace in Life.</p>
            </div>
            <div v-if="paymentStatus === 'FAILED'"
                 class="tw-bg-red-200 tw-rounded-lg tw-p-4 md:tw-mt-8 c-gray-text tw-mt-4">
              <p>Your Payment was NOT successful <br> You'll be required to retry paying</p>
            </div>

            <!-- Policy Issuance Loading -->
            <div v-if="loadingPolicyIssuance && paymentStatus === 'SUCCESSFUL'"
                 class="tw-bg-blue-50 tw-border tw-border-blue-200 tw-rounded-lg tw-p-4 tw-mt-4">
              <div class="tw-flex tw-items-center tw-justify-center tw-mb-2">
                <v-progress-circular size="20" color="primary" indeterminate class="tw-mr-3"></v-progress-circular>
                <span class="tw-text-blue-800 tw-font-semibold">Issuing your policy and sending details to your email...</span>
              </div>
              <p class="tw-text-blue-600 tw-text-sm tw-text-center">Please wait while we generate your travel insurance policy and send the documents to your email address.</p>
            </div>

            <!-- Policy Issued Successfully -->
            <div v-if="policyEmailSent && paymentStatus === 'SUCCESSFUL'"
                 class="tw-bg-gradient-to-r tw-from-green-50 tw-to-blue-50 tw-border tw-border-green-200 tw-rounded-lg tw-p-6 tw-mt-4">
              <div class="tw-flex tw-items-center tw-justify-center tw-mb-4">
                <v-icon color="success" size="48" class="tw-mr-3">mdi-email-check</v-icon>
                <h3 class="tw-text-green-800 tw-font-bold tw-text-lg">
                  Policy Documents Sent
                </h3>
              </div>

              <div class="tw-text-center tw-space-y-3">
                <p class="tw-text-green-700">
                  Your travel insurance policy has been successfully issued and the documents have been sent to your email address.
                </p>
                <p class="tw-text-sm tw-text-gray-600">
                  Policy documents were also sent to our underwriting and travel teams for processing.
                </p>
              </div>

              <div class="tw-mt-4 tw-p-3 tw-bg-green-100 tw-rounded-lg">
                <p class="tw-text-green-800 tw-text-sm tw-flex tw-items-start">
                  <v-icon color="success" size="16" class="tw-mr-2 tw-mt-0.5">mdi-information</v-icon>
                  <span>Check your email for the complete policy documents and keep them safe for your travels and any potential claims.</span>
                </p>
              </div>
            </div>
          </div>

          <div v-if="paymentRetry || paymentStatus === 'FAILED'"
               class="tw-mt-8 tw-px-4 tw-flex tw-justify-center">
            <v-btn
                color="secondary"
                @click="paymentInitiated = false"
            >Retry payment Request
            </v-btn>
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<!-- test -->
<!-- <script src="https://developer.tingg.africa/checkout/v2/tingg-checkout.js"></script> -->
<!-- Live -->
<script src="https://online.tingg.africa/v2/tingg-checkout.js"></script>
<script>
import CardTitle from '@/components/shared/CardTitle';
import BackNav from '@/components/buy/BackNav';
import helpers from '@/utils/helpers';
import validations from '@/utils/validations';
import axios from 'axios';
import { mapGetters } from 'vuex';
import firebase from '@/services/firebase/firebase';
import { FB_BUY_PAYMENT_FAILURE, FB_BUY_PAYMENT_INIT, FB_BUY_PAYMENT_SUCCESS } from '@/utils/const';
import TravelPolicyService from '@/services/TravelPolicyService';

export default {
  name: 'MakePayment',
  props: ['data'],
  components: {
    BackNav,
    CardTitle
  },
  data() {
    return {
      tab: null,
      currentTab: 'stk',
      loading: false,
      form: {},
      ...validations,
      stkValid: false,
      paymentInitiated: false,
      notificationAllowed: true,
      notificationDenied: false,
      paymentRetry: false,
      paymentGatewaySupported: true,
      walletSupported: false,
      stkSupported: true,
      statusLoaded: false,
      paymentStatus: 'PENDING',
      timeoutId: null,
      loadingPolicyIssuance: false,
      policyEmailSent: false,
    };
  },
  computed: {
    ...mapGetters('auth', ['authenticatedUser']),
  },
  mounted() {
    this.form = this.data.payment;
    if (firebase.messaging.isSupported()) {
      if (Notification.permission === 'default') {
        this.notificationAllowed = false;
      }
      if (Notification.permission === 'denied') {
        this.notificationDenied = true;
      }
    }
    // Hide Mpesa when limit exceeds 200K
    if (this.data.payment.payableAmount > 200000) {
      this.stkSupported = false;
    }
    this.$root.$on('failed-payment', () => {
      this.paymentRetry = true;
      this.paymentStatus = 'FAILED';
      this.cancelTimeout();
      this.$analytics.logEvent(FB_BUY_PAYMENT_FAILURE);
    });
    this.$root.$on('successful-payment', () => {
      this.cancelTimeout();
    });
  },
  methods: {
    requestSTK() {
      this.loading = true;
      this.paymentRetry = false;
      this.paymentStatus = 'PENDING';

      // Determine service type based on product type
      const paymentContext = this.$store.getters['payments/getPaymentContext'];

      // Check if this is a travel payment based on multiple indicators
      const checkPaymentContext = paymentContext?.productType === 'travel';
      const checkRouteQuery = this.$route.query.b === 'travel';
      const checkTransactionRef = this.data.payment.transactionReference &&
                                   (this.data.payment.transactionReference.includes('TRAVEL') || this.data.payment.transactionReference.startsWith('TR-'));

      const isTravelPayment = checkPaymentContext || checkRouteQuery || checkTransactionRef;
      const serviceType = isTravelPayment ? 'TRAVEL' : 'PORTAL';

      const data = {
        ...{
          serviceType: serviceType,
          transactionType: 'PAYMENT'
        }, ...this.$data.form
      };

      // console.log('STK Request Debug:', {
      //   paymentContext,
      //   routeQueryB: this.$route.query.b,
      //   transactionRef: this.data.payment.transactionReference,
      //   checkPaymentContext,
      //   checkRouteQuery,
      //   checkTransactionRef,
      //   isTravelPayment,
      //   serviceType,
      //   payload: data
      // });
      // live
      axios.post('/customer/payment/client-api/v1/payments/mpesa/stk/request', data)
          // test
          // axios.post('/customer/payment-test/client-api/v1/payments/mpesa/stk/request', data)
          .then((response) => {
            if (response?.data?.success) {
              this.$analytics.logEvent(FB_BUY_PAYMENT_INIT);
              this.$toast.success('Request sent, check your phone to finish the process', 'Payment');
              this.paymentInitiated = true;
              // check payment status after 30 secs
              this.timeoutId = setTimeout(() => {
                this.checkPaymentStatus(response.data.data.paymentId);
              }, 30000);
            } else {
              this.$toast.error('An Error occurred, please try again !', 'Payment');
            }
            this.loading = false;
          })
          .catch(() => {
            this.$toast.error('An Error occurred, please try again !', 'Payment');
            this.loading = false;
          });
    },
    requestNotification() {
      this.notificationAllowed = true;
      this.notificationDenied = false;
      this.$root.$emit('request-notification');
    },
    checkPaymentStatus(id) {
      // live
      axios.get(`/customer/payment/client-api/v1/payments/mpesa/payment/query?paymentId=${id}`)
          // test
          // axios.get(`/customer/payment-test/client-api/v1/payments/mpesa/payment/query?paymentId=${id}`)
          .then((resp) => {
            if (resp.data.success) {
              const status = resp.data.data.paymentStatus;
              this.paymentStatus = status;
              if (status === 'FAILED') {
                this.paymentRetry = true;
                this.$analytics.logEvent(FB_BUY_PAYMENT_FAILURE);
              }
              this.$analytics.logEvent(FB_BUY_PAYMENT_SUCCESS);

              // Auto-issue policy after successful payment for travel insurance
              if (status === 'SUCCESSFUL') {
                const paymentContext = this.$store.getters['payments/getPaymentContext'];
                if (paymentContext?.productType === 'travel') {
                  this.issueTravelPolicy(paymentContext);
                }
              }

              this.statusLoaded = true;
            }
          });
    },
    cancelTimeout() {
      clearTimeout(this.timeoutId);
    },
    requestPaymentGateway() {
      const names = this.authenticatedUser.name.split(' ');
      const firstName = names[0];
      const lastName = names[1];

      const payload = {
        // un-encrypted parameters collected against a request in json format
        requestAmount: this.data.payment.payableAmount,
        accountNumber: this.data.payment.transactionReference,
        requestDescription: this.data.payment.transactionDescription,
        msisdn: this.authenticatedUser.phone_number,
        firstName,
        lastName,
        email: this.authenticatedUser.email,
        successRedirectUrl: 'https://prod.api.pacisinsurance.com/pay-redirect',
        failRedirectUrl:  'https://prod.api.pacisinsurance.com/pay-redirect'
      };
      const checkoutType = 'redirect'; // or 'modal'
      this.loading = true;
      this.paymentRetry = false;
      this.paymentStatus = 'PENDING';
      // live
      axios.post('/customer/payment/client-api/v1/tingg/payments/encrypt', payload)
      // test
      // axios.post('/customer/payment-test/client-api/v1/tingg/payments/encrypt', payload)
          .then((response) => {
            if (response.data.success) {
              this.$analytics.logEvent(FB_BUY_PAYMENT_INIT);
              this.$toast.success('Request sent, enter payment info to finish the process', 'Payment');
              // this.paymentInitiated = true;
              Tingg.renderCheckout({
                merchantProperties: {
                  params: response.data.data,
                  accessKey: process.env.VUE_APP_TINGG_ACCESS_KEY,
                  countryCode: 'KE'
                },
                checkoutType,
                test: false,
              });
            } else {
              this.$toast.error('An Error occurred, please try again !', 'Payment');
            }
            this.loading = false;
          });
    },
    payByLink() {
      const names = this.authenticatedUser.name.split(' ');
      const firstName = names[0];
      const lastName = names[1];

      const payload = {
        // un-encrypted parameters collected against a request in json format
        requestAmount: this.data.payment.payableAmount,
        accountNumber: this.data.payment.transactionReference,
        requestDescription: this.data.payment.transactionDescription,
        msisdn: this.authenticatedUser.phone_number,
        firstName,
        lastName,
        email: this.authenticatedUser.email,
        successRedirectUrl: 'https://prod.api.pacisinsurance.com/pay-redirect',
        failRedirectUrl:  'https://prod.api.pacisinsurance.com/pay-redirect'
      };
      this.loading = true;
      this.paymentRetry = false;
      this.paymentStatus = 'PENDING';
      // live
      axios.post('/customer/payment/client-api/v1/tingg/payments/encrypt', payload)
      // test
      // axios.post('/customer/payment-test/client-api/v1/tingg/payments/encrypt', payload)
          .then((response) => {
            if (response.data.success) {
              axios.post('/customer/pay-by-link', { params: response.data.data, phoneNumber: this.$data.form.customerPhoneNumber})
                .then((response) => {
                  if (response.data.statusCode===200) {
                    this.$analytics.logEvent(FB_BUY_PAYMENT_INIT);
                    this.$toast.success('Request sent, check your phone to finish the process', 'Payment');
                } else {
                    this.$toast.error('An Error occurred, please try again !', 'Payment');
                } this.loading = false;
            });
            } else {
              this.$toast.error('An Error occurred, please try again !', 'Payment');
            }
            this.loading = false;
          });
    },

    async issueTravelPolicy(paymentContext) {
      try {
        this.loadingPolicyIssuance = true;
        const result = await TravelPolicyService.issueTravelPolicy(paymentContext, this.$store);
        this.policyEmailSent = true;
        this.$toast.success(result.message, 'Policy Issued');
      } catch (error) {
        // console.error('Failed to issue travel policy:', error);
        this.$toast.error(error.message || 'Policy issuance failed. Please contact support for assistance.', 'Issuance Error');
      } finally {
        this.loadingPolicyIssuance = false;
      }
    }
  },
  filters: {
    formatNum(num) {
      return helpers.numberToString(num);
    },
  },
};
</script>
<style>
.v-tabs-slider {
  background-color: #fff !important;
}
</style>
